import React, {useCallback, useRef, useState, useEffect} from 'react';
import panelStyles from "components/homePanels/Panels.module.scss";
import ImageGalleryStatic from "./imageGallery/ImageGalleryStatic";
import ImageWrapper from "components/imageWrapper/ImageWrapper";
import {buttonClick} from "utils/Helpers";
import mainStyles from "components/homeParallax/HomeParallax.module.scss";
import PanelAnimations from "utils/PanelAnimations";
import MouseMove from "utils/MouseMove";
import Tilt from "utils/Tilt";
import {useDispatch, useSelector} from "react-redux";
import NavToggle from "components/icons/navToggle/NavToggle";
import styles from './OriginalsUGC.module.scss'
import DetailsModal from "components/homePanels/e_contest/detailsModal/DetailsModal";
import Disclaimer from "components/homePanels/e_contest/disclaimer/Disclaimer";
import LogoSprite from "components/logoSprite/LogoSprite";
import Finalist from "components/homePanels/e_contest/finalist/Finalist";
import Winners from "components/homePanels/e_contest/winners/Winners";


const OriginalsUGC = (props) => {

    // const windowData = useSelector(state => state.window);
    const accessible = useSelector(state => state.accessible);
    const dispatch = useDispatch()
    const hero = useRef();
    const button = useRef();
    const foreGround = useRef();
    const bonusGround = useRef();
    const midGround = useRef();
    const backGround = useRef();
    const fixedStage = useRef();
    const [activeGallery, toggleActiveGallery] = useState(false);

    const [finalistsModal, toggleFinalistsModal] = useState(false);
    const [winnersModal, toggleWinnersModal] = useState(false);

    const [error, setError] = useState(null)
    const stageTitle = useRef();

    const ExploreFinalist = useCallback((open,type) =>{
        if(type === 'finalists'){
            toggleFinalistsModal(open)
        } else {
            toggleWinnersModal(open)
        }

        dispatch({ type: "SET_ACCESSIBLE",
            payload: {
                ...accessible,
                exploring: open,
                contestModal: open
            }
        });
    }, [accessible,dispatch,toggleFinalistsModal,toggleWinnersModal]);

    const browseSubmissions = useCallback((open) =>{

        if(finalistsModal) ExploreFinalist(false, 'finalists')
        if(winnersModal) ExploreFinalist(false, 'winners')

        toggleActiveGallery(open)
        dispatch({ type: "SET_ACCESSIBLE",
            payload: {
                ...accessible,
                exploring: open,
                galleryModal: open
            }
        });
    }, [accessible,dispatch,ExploreFinalist,finalistsModal,winnersModal]);



    useEffect(()=>{
        if(!accessible.modalOpen && stageTitle.current) stageTitle.current.focus();
    },[accessible.modalOpen])

    useEffect(()=>{

        const escapeCheck = (e) => {
            let key = e.key !== undefined ? e.key : e.keyCode;

            if(key === 27 || key === 'Escape') {

                if(activeGallery) browseSubmissions(false);
                if(finalistsModal) ExploreFinalist(false, 'finalists')
                if(winnersModal) ExploreFinalist(false, 'winners')

            }

        }

        document.addEventListener('keydown', escapeCheck);
        return ()=>document.removeEventListener('keydown', escapeCheck)
    }, [browseSubmissions,activeGallery,finalistsModal,winnersModal,ExploreFinalist])

    // const closeEntriesOpenFinalist = () => {
    //     browseSubmissions(false);
    //     ExploreFinalist(true, 'finalists');
    // }

    const closeEntriesOpenWinners = () => {
        browseSubmissions(false);
        ExploreFinalist(true, 'winners');
    }

    function buildGallery(){
        if(activeGallery){
            return (
                <div className={styles.gallery}>
                    <DetailsModal error={error}/>
                    <Disclaimer/>
                    <div tabIndex={0} role={'button'} onKeyDown={buttonClick} aria-label={'Close Gallery'}  className={styles.close} onClick={() => browseSubmissions(false)}>
                        <NavToggle menuOpen={true} closeOnly={true} color={'#fff'}/>
                    </div>
                    <span tabIndex={accessible.siteEntered && !accessible.modalOpen ? 0 : null} role={'button'} aria-label={'Meet the winners'} onKeyDown={buttonClick}
                          className={`explore ${panelStyles.explore} ${panelStyles.button} ${panelStyles.white} ${styles.button}`} onClick={closeEntriesOpenWinners}>
                                    <span className={`${panelStyles.ctaText}`} dangerouslySetInnerHTML={{__html:'Meet the winners'}}/><span className={panelStyles.carat}>&rsaquo;&rsaquo;</span>
                                </span>
                    <ImageGalleryStatic setError={setError}/>
                </div>
            )
        }
    }

    function showFinalists(){
        if(finalistsModal){
            return (
                <div className={styles.gallery}>
                    <div tabIndex={0} role={'button'} onKeyDown={buttonClick} aria-label={'Close Finalist'}  className={styles.close} onClick={() => ExploreFinalist(false, 'finalists')}>
                        <NavToggle menuOpen={true} closeOnly={true} color={'#fff'}/>
                    </div>
                    <Finalist showGallery={()=>browseSubmissions(true)}/>
                </div>
            )
        }
    }

    const closeHome = () => {
        ExploreFinalist(false, 'winners');
        props.menuClick('introText')
    }

    function showWinners(){
        if(winnersModal){
            return (
                <div className={styles.gallery}>
                    <div tabIndex={0} role={'button'} onKeyDown={buttonClick} aria-label={'Close Winners'}  className={styles.close} onClick={() => ExploreFinalist(false, 'winners')}>
                        <NavToggle menuOpen={true} closeOnly={true} color={'#fff'}/>
                    </div>
                    <Winners showGallery={()=>browseSubmissions(true)} close={closeHome}/>
                </div>
            )
        }
    }

    return (

        <>

            {buildGallery()}
            {showFinalists()}
            {showWinners()}

            <div ref={fixedStage} data-status={props.status} className={`${styles.stage} ${panelStyles.fixedStage}`} style={{zIndex: props.zIndex}}>

                <div ref={hero} className={`${panelStyles.hero}`}>
                    <div ref={foreGround}  className={`${panelStyles.foreGround}`}>

                        <LogoSprite sprite={'https://msobd-storage.azureedge.net/images/gallery/originals_sprite_v2.png'} duration={3.5} steps={49} delay={3} size={385}/>

                        <div className={`${panelStyles.info} ${styles.info}`}>
                            <h3 ref={stageTitle} tabIndex={-1}>Surface Originals</h3>

                             {/*FINALIST*/}
                            {/*<span tabIndex={accessible.siteEntered && !accessible.modalOpen ? 0 : null} role={'button'} aria-label={'Explore the finalists'} onKeyDown={buttonClick}*/}
                            {/*      ref={button} className={`explore ${panelStyles.explore} ${panelStyles.button} ${panelStyles.white}`} onClick={()=>ExploreFinalist(true, 'finalists')}>*/}
                            {/*        <span className={`${panelStyles.ctaText}`} dangerouslySetInnerHTML={{__html:'Explore the finalists'}}/><span className={panelStyles.carat}>&rsaquo;&rsaquo;</span>*/}
                            {/*    </span>*/}

                            {/* WINNERS */}
                            <span tabIndex={accessible.siteEntered && !accessible.modalOpen ? 0 : null} role={'button'} aria-label={'Meet the winners'} onKeyDown={buttonClick}
                                  ref={button} className={`explore ${panelStyles.explore} ${panelStyles.button} ${panelStyles.white}`} onClick={()=>ExploreFinalist(true, 'winners')}>
                                    <span className={`${panelStyles.ctaText}`} dangerouslySetInnerHTML={{__html:'Meet the winners'}}/><span className={panelStyles.carat}>&rsaquo;&rsaquo;</span>
                                </span>
                        </div>

                    </div>

                </div>

                <div aria-hidden={true} ref={bonusGround} className={`${panelStyles.bonusGround}`}>
                    <ImageWrapper className={styles.bonusGround} set={{
                        // 800:`https://msobd-storage.azureedge.net/images/gallery/bonusGround_800.png`,
                        800:`data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjYGBg+A8AAQQBAHAgZQsAAAAASUVORK5CYII=`,
                        default:`https://msobd-storage.azureedge.net/images/gallery/bonusGround_v2.png`}} alt={''}/>
                </div>

                <div aria-hidden={true} ref={midGround} className={`${panelStyles.midGround}`}>
                    <ImageWrapper className={styles.midGround} set={{
                        // 800:`https://msobd-storage.azureedge.net/images/gallery/midGround_800.png`,
                        800:`data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjYGBg+A8AAQQBAHAgZQsAAAAASUVORK5CYII=`,
                        default:`https://msobd-storage.azureedge.net/images/gallery/midGround_v2.png`}} alt={''}/>
                </div>

                <div aria-hidden={true} ref={backGround} className={`${panelStyles.backGround} ${styles.bg}`}>
                    <ImageWrapper className={styles.backGround} set={{
                        // 800:`https://msobd-storage.azureedge.net/images/gallery/background_800.gif`,
                        800:`data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjYGBg+A8AAQQBAHAgZQsAAAAASUVORK5CYII=`,
                        default:`https://msobd-storage.azureedge.net/images/gallery/backGround_v2.jpg`}} alt={''}/>
                </div>



                <span className={mainStyles.accessibleContent} tabIndex={accessible.siteEntered && !accessible.modalOpen ? 0 : null} role={'button'} aria-label={'Navigate to next section'} onKeyDown={buttonClick} onClick={props.nextPanel}/>
                <span className={mainStyles.accessibleContent} tabIndex={accessible.siteEntered && !accessible.modalOpen ? 0 : null} role={'button'} aria-label={'Navigate to previous section'} onKeyDown={buttonClick} onClick={props.prevPanel}/>

                <PanelAnimations fixedStage={fixedStage} backGround={backGround} foreGround={foreGround} midGround={midGround} bonusGround={bonusGround} panel={'contest'}/>

                <MouseMove status={props.status} backGround={backGround} midGround={midGround} bonusGround={bonusGround} />

                <Tilt backGround={backGround}  midGround={midGround} bonusGround={bonusGround}/>

                <ImageWrapper aria-hidden={true} className={styles.noShow} set={{default:`https://msobd-storage.azureedge.net/images/gallery/originals_sprite_v2.png`}} alt={''}/>

            </div>

        </>
    )
};

export default OriginalsUGC
